import React from 'react';
export function BeforeAfter() {
  return <section id="gallery" className="py-24 bg-surface border-y border-accent/10" data-id="element-12">
      <div className="container mx-auto px-4" data-id="element-13">
        <div className="text-center mb-16" data-id="element-14">
          <h2 className="font-display text-4xl md:text-5xl text-white uppercase tracking-wide mb-4" data-id="element-15">
            Recent <span className="text-accent" data-id="element-16">Projects</span>
          </h2>
          <p className="text-slate-400 max-w-2xl mx-auto text-lg" data-id="element-17">
            Take a look at some of our recent emergency plumbing repairs and
            installations across the Phoenix Valley.
          </p>
        </div>

        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-18">
          <div className="flex flex-col gap-4" data-id="element-19">
            <div className="relative w-full aspect-[3/4] rounded-xl overflow-hidden border-2 border-accent/30 shadow-2xl" data-id="element-20">
              <img src="https://cdn.magicpatterns.com/uploads/uQybK6eJ2yvDK99N6kDshE/612140872_17852036904606185_7351081117603556339_n.webp" alt="Tankless Water Heater Installation" className="w-full h-full object-cover" data-id="element-21" />
            </div>
            <h3 className="text-xl font-bold text-white text-center" data-id="element-22">
              Tankless Water Heaters
            </h3>
          </div>
          <div className="flex flex-col gap-4" data-id="element-23">
            <div className="relative w-full aspect-[3/4] rounded-xl overflow-hidden border-2 border-accent/30 shadow-2xl" data-id="element-24">
              <img src="https://cdn.magicpatterns.com/uploads/mZpgC4n3KPwzaroTuXmvfm/612950573_17852223006606185_3266372455388356444_n.webp" alt="Kitchen Faucet Installation" className="w-full h-full object-cover" data-id="element-25" />
            </div>
            <h3 className="text-xl font-bold text-white text-center" data-id="element-26">
              Fixture Upgrades
            </h3>
          </div>
          <div className="flex flex-col gap-4" data-id="element-27">
            <div className="relative w-full aspect-[3/4] rounded-xl overflow-hidden border-2 border-accent/30 shadow-2xl" data-id="element-28">
              <img src="https://cdn.magicpatterns.com/uploads/dUb4KEca9FAVnjB1ozQig2/639735305_1373566027874546_7337869266499896147_n.jpg" alt="Toilet Installation" className="w-full h-full object-cover" data-id="element-29" />
            </div>
            <h3 className="text-xl font-bold text-white text-center" data-id="element-30">
              Bathroom Plumbing
            </h3>
          </div>
        </div>
      </div>
    </section>;
}